import { render, staticRenderFns } from "./performance-container.vue?vue&type=template&id=3ca291ee&scoped=true"
import script from "./performance-container.vue?vue&type=script&lang=js"
export * from "./performance-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca291ee",
  null
  
)

export default component.exports